var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinRound(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 33,
    viewBox: "0 0 34 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.5317 16.213L15.6159 14.4117C15.2742 14.2553 14.9935 14.4306 14.9935 14.8036V18.1964C14.9935 18.5694 15.2742 18.7447 15.6159 18.5883L19.5299 16.787C19.8734 16.6289 19.8734 16.3711 19.5317 16.213ZM16.7369 0C7.49327 0 0 7.38719 0 16.5C0 25.6128 7.49327 33 16.7369 33C25.9806 33 33.4739 25.6128 33.4739 16.5C33.4739 7.38719 25.9806 0 16.7369 0ZM16.7369 23.2031C8.16972 23.2031 8.01979 22.4417 8.01979 16.5C8.01979 10.5583 8.16972 9.79687 16.7369 9.79687C25.3042 9.79687 25.4541 10.5583 25.4541 16.5C25.4541 22.4417 25.3042 23.2031 16.7369 23.2031Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinRound);
export default __webpack_public_path__ + "static/media/linkedin-round.afe533e97066b542d22c38162a5c46ab.svg";
export { ForwardRef as ReactComponent };